export type MtgFormat = "commander" | "standard" | "modern" | "pioneer" | "legacy" | "vintage" | "pauper" | "historic" | string;

export function isIllegalInFormat(scryfallFull: any | null | undefined, fmt: MtgFormat): { illegal: boolean; reason: string | null } {
  if (!fmt) return { illegal: false, reason: null };
  const legalities = scryfallFull?.legalities;
  if (!legalities) return { illegal: false, reason: null }; // unknown => don’t flag
  const key = fmt.toLowerCase();
  const val = legalities[key];
  if (!val) return { illegal: false, reason: null };
  const illegal = !(val === "legal" || val === "restricted");
  return { illegal, reason: illegal ? `Not legal in ${fmt}` : null };
}

export function deckColorIcons(colorIdentity: string[] | null | undefined) {
  const order: Array<"W"|"U"|"B"|"R"|"G"> = ["W","U","B","R","G"];
  const map: Record<string, string> = {
    W: "/images/icons/white.png",
    U: "/images/icons/blue.png",
    B: "/images/icons/black.png",
    R: "/images/icons/red.png",
    G: "/images/icons/green.png",
  };
  const uniq = Array.from(new Set((colorIdentity || []).map((x) => String(x).toUpperCase()))).filter((x) => order.includes(x as any)) as Array<"W"|"U"|"B"|"R"|"G">;
  const sorted = order.filter((c) => uniq.includes(c));
  return sorted.map((c) => ({ key: c, src: map[c], alt: c }));
}

export function buildDeckExportText(rows: Array<{ name: string; set?: string | null; number?: string | null; qty?: number | null }>) {
  return rows
    .map((r) => {
      const qty = r.qty && r.qty > 0 ? r.qty : 1;
      const set = (r.set || "").toUpperCase();
      const num = r.number || "";
      const setPart = set || num ? ` (${set}) ${num}` : "";
      return `${qty} ${r.name}${setPart}`.trim();
    })
    .join("\n");
}
